
import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import OrderAssignDialog from "../../../components/customHelpers/OrderAssignDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import { Grid, Box, TableCell, TableRow, TableBody, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import { MdAssignmentInd } from "react-icons/md";
import Admin from "../../../components/auth/Admin";
import Order from "../../../actions/order";
import UpdateOrder from "../../../components/forms/addOrders";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { useHistory } from "react-router-dom";
import Assigntff from "./assignToUser";
import { isAuth } from "../../../actions/auth";
import {
  Paper,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from "@mui/material";
import { formatNumber } from "../../../utils/utils";
import InfoComponent from "../../../components/InfoComponent";
import { statusBadge } from "../../../components/statusBadge";

const headCells = [
  { id: "id", label: "Id" },
  { id: "customer", label: "Customer" },
  { id: "assignTo", label: "Assigned To" },
  { id: "quantity", label: "Item Count" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const radioOptions = [
  { label: "My Created Order", value: "myCreatedOrder" },
  { label: "My Assigned Order", value: "myAssignedOrder" },
  { label: "All", value: "all" },
];

const ShipmentOrder = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewShipmentOrders, viewUserShipmentOrders, deleteMainOrder } =
    Order();
  const [recordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  const [edit] = useState(false);
  const [id, setId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [temp, setTemp] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  const [checkedItems, setCheckedItems] = useState("all");

  useEffect(() => {
    getAllShipmentOrders();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [orderConfirmDialog, setOrderConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [additionalConfirmDialog, setAdditionalConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => {},
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllShipmentOrders = () => {
    setValues({ ...values, loading: true });
    viewShipmentOrders().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        const modifiedOrders = data.orders.map((order) => ({
          ...order,
          customer: order?.customer?.fullName,
        }));
        setOrders(modifiedOrders);
        setTemp(modifiedOrders);
        setCheckedItems("all");
      }
    });
  };

  const getUserShipmentOrders = () => {
    setValues({ ...values, loading: true });
    viewUserShipmentOrders().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setOrders(data.orders);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteMainOrder(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setOrders(
          produce(orders, (draft) => {
            const index = orders.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(orders, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["status", "customer", "id"];
        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2);
    }
  };

  const handleTypeChange = (e) => {
    const value = e.target.value;
    setCheckedItems(value);
    if (value === "myAssignedOrder") {
      const filteredOrders = temp.filter(
        (order) => order.assignTo === isAuth()?.id
      );
      setOrders(filteredOrders);
    } else if (value === "myCreatedOrder") {
      const filteredOrders = temp.filter(
        (order) => order.uploded_by === isAuth()?.id
      );
      setOrders(filteredOrders);
    } else {
      setOrders(temp);
    }
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" className="page-header">
              Shipment Orders
            </Typography>
          </Box>
          <InfoComponent pageKey="shipmentOrders" />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            flexWrap="wrap"
          >
            <div
              className="search-header-container"
              style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
            >
              <div className="search-header-flex">
                <div className="search-container">
                  <AiOutlineSearch className="search_icon" />
                  <input
                    type="text"
                    onChange={handleSearch}
                    placeholder="Search Shipment"
                    className="search-input"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>

            <Box display="flex" marginBottom={4} alignItems="center" gap={2}>
              <FormControl
                size="small"
                sx={{
                  minWidth: 150,
                  maxWidth: 150,
                  borderRadius: 1,
                  height: 30,
                }}
              >
                <InputLabel
                  id="order-type-select-label"
                  sx={{
                    fontSize: "0.8rem",
                    top: "-7px",
                  }}
                >
                  Order Type
                </InputLabel>
                <MuiSelect
                  labelId="order-type-select-label"
                  id="order-type-select"
                  value={checkedItems}
                  label="Order Type"
                  onChange={handleTypeChange}
                  sx={{
                    "& .MuiSelect-select": {
                      fontSize: "0.85rem",
                      padding: "11px 8px",
                      color: "#616161",
                    },
                    "& .Mui-selected": {
                      background: "rgba(244,151,3,.8)",
                      color: "#fff",
                      fontSize: "0.87px",
                    },
                  }}
                >
                  {radioOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </MuiSelect>
              </FormControl>
            </Box>
          </Box>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody className="page-table-body">
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell className="page-table-cell">
                              {item.orderId
                                ? item.orderId
                                : `${item.id.slice(0, 7)}--`}
                            </TableCell>
                            <TableCell className="page-table-cell">
                              <div className="page-customer-name">
                                {item.customer}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden lg:table-cell">
                              <div className="page-assigned-to">
                                {item.staff?.fullName}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden xl:table-cell">
                              <div className="page-item-count">
                                <span className="page-item-badge">
                                  {item?.orderProducts?.length || 0}
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell">
                              <div className="page-total">
                                {item?.orderProducts?.length > 0
                                  ? formatNumber(
                                      calculateTotalPrice(item.orderProducts)
                                    )
                                  : 0}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden sm:table-cell">
                              <div className="page-paid">
                                {formatNumber(item.paid || 0)}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden sm:table-cell">
                              <div
                                className={`page-balance ${
                                  parseFloat(
                                    (
                                      Number(
                                        calculateTotalPrice(
                                          item.orderProducts
                                        ) || 0
                                      ) - Number(item.paid || 0)
                                    ).toString()
                                  ) < 0
                                    ? "text-red-600"
                                    : parseFloat(
                                        (
                                          Number(
                                            calculateTotalPrice(
                                              item.orderProducts
                                            ) || 0
                                          ) - Number(item.paid || 0)
                                        ).toString()
                                      ) > 0
                                    ? "text-amber-600"
                                    : "text-emerald-600"
                                }`}
                              >
                                {formatNumber(
                                  Number(
                                    calculateTotalPrice(item.orderProducts) || 0
                                  ) - Number(item.paid || 0)
                                )}
                              </div>
                            </TableCell>
                            <TableCell>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                            <TableCell className="page-table-cell">
                              {statusBadge(item.status || "Unknown")}
                            </TableCell>
                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                }}
                              >
                                <Controls.ActionButton
                                  color="primary"
                                  title="View Detail"
                                  onClick={() => {
                                    history.push(
                                      `/shipment/${
                                        item.orderId ? item.orderId : item.id
                                      }`
                                    );
                                  }}
                                >
                                  <FiEye fontSize="medium" />
                                </Controls.ActionButton>
                                <Controls.ActionButton
                                  color="primary"
                                  title="Assign"
                                  onClick={() => {
                                    setOpenPopupAssign(true);
                                    setId(item.id);
                                  }}
                                >
                                  <MdAssignmentInd fontSize="medium" />
                                </Controls.ActionButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <ConfirmDialog
            confirmDialog={additionalConfirmDialog}
            setConfirmDialog={setAdditionalConfirmDialog}
          />
          <OrderAssignDialog
            confirmDialog={orderConfirmDialog}
            setConfirmDialog={setOrderConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Order Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <UpdateOrder
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllShipmentOrders}
            edit={edit}
          />
        </Popup>
        <Popup
          title="Assign User"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <Assigntff
            type="Shipment"
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllShipmentOrders}
            edit={edit}
            handleStatusChange={null}
            event={null}
            id={id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default ShipmentOrder;
